"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerContextService = exports.DEALER_ID_VTP_STORE_TIMEOUT = exports.DEALER_ID_META_ATTRIBUTE = void 0;
const storage_1 = require("./storage");
const fetch_dealer_id_1 = require("./fetch-dealer-id");
exports.DEALER_ID_META_ATTRIBUTE = 'oadd-dealer-id';
exports.DEALER_ID_VTP_STORE_TIMEOUT = 4000;
const DealerContextService = () => {
    const subscribers = new Set();
    let dealerId = storage_1.readDealerIdFromStorage();
    const getSelectedDealer = () => dealerId;
    const subscribe = (callbackFn) => {
        subscribers.add(callbackFn);
        callbackFn(dealerId);
        return () => {
            subscribers.delete(callbackFn);
        };
    };
    const setSelectedDealer = (newDealerId) => {
        dealerId = newDealerId;
        for (const subscriber of subscribers) {
            subscriber(dealerId);
        }
        storage_1.writeDealerIdToStorage(dealerId);
    };
    const initialize = () => {
        fetch_dealer_id_1.fetchDealerId().then((id) => {
            if (id) {
                setSelectedDealer(id);
            }
        });
    };
    initialize();
    return {
        getSelectedDealer,
        setSelectedDealer,
        subscribe,
    };
};
exports.DealerContextService = DealerContextService;
//# sourceMappingURL=dealer-context-service.js.map